import { useCallback, useMemo } from 'react'

import { useDroppable } from '@dnd-kit/core'
import { SortingStrategy, verticalListSortingStrategy } from '@dnd-kit/sortable'

import { DraggableTypes } from 'features/views/LayoutEditor/types'
import { useLayoutEditorWidgetAreaContext } from 'features/views/LayoutEditor/useLayoutEditorWidgetAreaContext'
import { useLayoutEditorWidgetContext } from 'features/views/LayoutEditor/useLayoutEditorWidgetContext'

import useDeepEqualsMemoValue from 'v2/ui/utils/useDeepEqualsMemoValue'

type UseLayoutEditorWidgetAreaStateOptions = {
    id: string
}

export function useLayoutEditorWidgetAreaState(options: UseLayoutEditorWidgetAreaStateOptions) {
    const { id } = options

    const { children, path } = useLayoutEditorWidgetAreaContext()!
    const { isDragging = false, widget } = useLayoutEditorWidgetContext() ?? {}

    const childrenLength = children.length

    const sortableContextId = widget ? `${widget.id}.${id}` : id

    const { setNodeRef: ref } = useDroppable({
        id: sortableContextId,
        data: {
            id,
            type: DraggableTypes.WidgetArea,
            path,
            childrenCount: childrenLength,
        },
        disabled: isDragging,
    })

    const sortingStrategy: SortingStrategy = useCallback((args) => {
        return verticalListSortingStrategy(args)
    }, [])

    const sortableItems = useDeepEqualsMemoValue(children.map((child) => child.id))

    return useMemo(
        () => ({
            childrenLength,
            ref,
            sortableContextId,
            isDragging,
            sortingStrategy,
            sortableItems,
        }),
        [childrenLength, isDragging, ref, sortableContextId, sortingStrategy, sortableItems]
    )
}
